import { action, createRequestTypes } from '../base';

export const tallyIntegrationActionTypes = {
  GET_TALLY_CONNECTIONS: createRequestTypes('GET_TALLY_CONNECTIONS'),
  DELETE_TALLY_CONNECTION: createRequestTypes('DELETE_TALLY_CONNECTION'),
  CONNECT_TO_TALLY: createRequestTypes('CONNECT_TO_TALLY'),
  CONNECT_TENANT_TO_TALLY_LOCATION: createRequestTypes('CONNECT_TENANT_TO_TALLY_LOCATION'),
  SYNC_TALLY_PRODUCT: createRequestTypes('SYNC_TALLY_PRODUCT'),
  SYNC_TALLY_VENDOR: createRequestTypes('SYNC_TALLY_VENDOR'),
  SYNC_TALLY_GRN: createRequestTypes('SYNC_TALLY_GRN'),
  SYNC_TALLY_PO: createRequestTypes('SYNC_TALLY_PO'),
  SYNC_TALLY_DN: createRequestTypes('SYNC_TALLY_DN'),
  PULL_TALLY_PRODUCTS: createRequestTypes('PULL_TALLY_PRODUCTS'),
  PULL_TALLY_VENDORS: createRequestTypes('PULL_TALLY_VENDORS'),
  PULL_TALLY_VENDOR_PAYMENT: createRequestTypes('PULL_TALLY_VENDOR_PAYMENT'),
  SYNC_TALLY_INVOICE: createRequestTypes('SYNC_TALLY_INVOICE'),
  SYNC_TALLY_CN: createRequestTypes('SYNC_TALLY_CN'),
  REFRESH_TALLY_CONNECTIONS: createRequestTypes('REFRESH_TALLY_CONNECTIONS'),
  PULL_TALLY_CUSTOMERS: createRequestTypes('PULL_TALLY_CUSTOMERS'),
  GET_TALLY_DOCUMENTS: createRequestTypes('GET_TALLY_DOCUMENTS'),
  GET_TALLY_UNMAPPED_DOCUMENTS: createRequestTypes('GET_TALLY_UNMAPPED_DOCUMENTS'),
  UPDATE_TALLY_EXCLUDED_DOCUMENTS: createRequestTypes('UPDATE_TALLY_EXCLUDED_DOCUMENTS'),
  SYNC_TALLY_DOCUMENTS: createRequestTypes('SYNC_TALLY_DOCUMENTS'),
  TALLY_DOCUMENTS_COUNT: createRequestTypes('TALLY_DOCUMENTS_COUNT'),
};

/**
 * @param payload
 * @param linkedDaData
 * @param connectToTallySuccess
 * @param callback
 * @param orgId
 */
class TallyIntegrationActions {
  getTallyConnections = (orgId, callback, tallyId) => action(tallyIntegrationActionTypes.GET_TALLY_CONNECTIONS.REQUEST, {
    orgId, callback, tallyId

    })

    /**
     *
     * @param {*} getTallyConnectionsLoading
     * @return
     */
    getTallyConnectionsLoading = (getTallyConnectionsLoading) => action(tallyIntegrationActionTypes.GET_TALLY_CONNECTIONS.LOADING, {
      getTallyConnectionsLoading,
    })

     /**
      * @return
      * @param linkedDaData
      */
     getTallyConnectionsSuccess = (tallyConnections) => action(tallyIntegrationActionTypes.GET_TALLY_CONNECTIONS.SUCCESS, {
       tallyConnections,
     })

     /**
       *
       * @param {*} payload
       * @param {*} callback
       * @returns
       */
      deleteTallyConnection = (payload, callback) => action(tallyIntegrationActionTypes.DELETE_TALLY_CONNECTION.REQUEST, {
        payload, callback,
      })

      /**
      *
      * @param {*} deleteTallyConnectionLoading
      * @returns
      */
       deleteTallyConnectionLoading = (deleteTallyConnectionLoading) => action(tallyIntegrationActionTypes.DELETE_TALLY_CONNECTION.LOADING, {
         deleteTallyConnectionLoading,
       })

     /**
        * @return
        * @param payload
        * @param callback
        */
     connectToTally = (payload, callback) => action(tallyIntegrationActionTypes.CONNECT_TO_TALLY.REQUEST, {
       payload, callback,
     })

      /**
       * @return
       * @param connectToTallyLoading
       */
      connectToTallyLoading = (connectToTallyLoading) => action(tallyIntegrationActionTypes.CONNECT_TO_TALLY.LOADING, {
        connectToTallyLoading,
      })

      // /**
      //  *
      //  * @param {*} connectedToTally
      //  * @returns
      //  */
      // connectToTallySuccess = (connectedToTally) => action(tallyIntegrationActionTypes.CONNECT_TO_TALLY.SUCCESS, {
      //   connectedToTally,
      // })

      /**
       * @param {*} payload
       * @param callback
       * @return
       */
       connectTenantToTallyLocation = (payload, callback) => action(tallyIntegrationActionTypes.CONNECT_TENANT_TO_TALLY_LOCATION.REQUEST, {
         payload, callback,
       })

       /**
       * @return
       * @param connectTenantToTallyLocationLoading
       */
       connectTenantToTallyLocationLoading = (connectTenantToTallyLocationLoading) => action(tallyIntegrationActionTypes.CONNECT_TENANT_TO_TALLY_LOCATION.LOADING, {
         connectTenantToTallyLocationLoading,
       })

       /**
       *
       * @param {*} payload
       * @param {*} callback
       * @returns
       */
       syncProduct = (payload, callback) => action(tallyIntegrationActionTypes.SYNC_TALLY_PRODUCT.REQUEST, {
         payload, callback,
       })

      /**
       *
       * @param {*} syncProductLoading
       * @returns
       */
      syncProductLoading = (syncProductLoading) => action(tallyIntegrationActionTypes.SYNC_TALLY_PRODUCT.LOADING, {
        syncProductLoading,
      })

      /**
       *
       * @param {*} payload
       * @param {*} callback
       * @returns
       */
       syncVendor = (payload, callback) => action(tallyIntegrationActionTypes.SYNC_TALLY_VENDOR.REQUEST, {
         payload, callback,
       })

      /**
       *
       * @param {*} syncVendorLoading
       * @returns
       */
      syncVendorLoading = (syncVendorLoading) => action(tallyIntegrationActionTypes.SYNC_TALLY_VENDOR.LOADING, {
        syncVendorLoading,
      })

      /**
       *
       * @param {*} payload
       * @param {*} callback
       * @returns
       */
       syncTallyGRN = (payload, callback) => action(tallyIntegrationActionTypes.SYNC_TALLY_GRN.REQUEST, {
         payload, callback,
       })

       /**
       *
       * @param {*} syncTallyGRNLoading
       * @returns
       */
       syncTallyGRNLoading = (syncTallyGRNLoading) => action(tallyIntegrationActionTypes.SYNC_TALLY_GRN.LOADING, {
         syncTallyGRNLoading,
       })

       /**
 *
 * @param {*} payload
 * @param {*} callback
 * @returns
 */
         syncTallyInvoice = (payload, callback) => action(tallyIntegrationActionTypes.SYNC_TALLY_INVOICE.REQUEST, {
           payload, callback,
         })

       /**
       *
       * @param {*} syncTallyInvoiceLoading
       * @returns
       */
       syncTallyInvoiceLoading = (syncTallyInvoiceLoading) => action(tallyIntegrationActionTypes.SYNC_TALLY_INVOICE.LOADING, {
         syncTallyInvoiceLoading,
       })

         /**
 *
 * @param {*} payload
 * @param {*} callback
 * @returns
 */
         syncTallyCreditNote = (payload, callback) => action(tallyIntegrationActionTypes.SYNC_TALLY_CN.REQUEST, {
           payload, callback,
         })

       /**
       *
       * @param {*} syncTallyCreditNoteLoading
       * @returns
       */
       syncTallyCreditNoteLoading = (syncTallyCreditNoteLoading) => action(tallyIntegrationActionTypes.SYNC_TALLY_CN.LOADING, {
         syncTallyCreditNoteLoading,
       })

       /**
       *
       * @param {*} payload
       * @param {*} callback
       * @returns
       */
       syncPO = (payload, callback) => action(tallyIntegrationActionTypes.SYNC_TALLY_PO.REQUEST, {
         payload, callback,
       })

      /**
       *
       * @param {*} syncPOLoading
       * @returns
       */
      syncPOLoading = (syncPOLoading) => action(tallyIntegrationActionTypes.SYNC_TALLY_PO.LOADING, {
        syncPOLoading,
      })

      /**
       *
       * @param {*} payload
       * @param {*} callback
       * @returns
       */
       syncDN = (payload, callback) => action(tallyIntegrationActionTypes.SYNC_TALLY_DN.REQUEST, {
         payload, callback,
       })

      /**
       *
       * @param {*} syncDNLoading
       * @returns
       */
      syncDNLoading = (syncDNLoading) => action(tallyIntegrationActionTypes.SYNC_TALLY_DN.LOADING, {
        syncDNLoading,
      })

      /**
       *
       * @param {*} payload
       * @param {*} callback
       * @returns
       */
       pullTallyProducts = (payload, callback) => action(tallyIntegrationActionTypes.PULL_TALLY_PRODUCTS.REQUEST, {
         payload, callback,
       })

       /**
       *
       * @param {*} pullTallyProductsLoading
       * @returns
       */
       pullTallyProductsLoading = (pullTallyProductsLoading) => action(tallyIntegrationActionTypes.PULL_TALLY_PRODUCTS.LOADING, {
         pullTallyProductsLoading,
       })

       /**
       *
       * @param {*} payload
       * @param {*} callback
       * @returns
       */
        pullTallyVendors = (payload, callback) => action(tallyIntegrationActionTypes.PULL_TALLY_VENDORS.REQUEST, {
          payload, callback,
        })

       /**
       *
       * @param {*} pullTallyVendorsLoading
       * @returns
       */
       pullTallyVendorsLoading = (pullTallyVendorsLoading) => action(tallyIntegrationActionTypes.PULL_TALLY_VENDORS.LOADING, {
         pullTallyVendorsLoading,
       })

       /**
       *
       * @param {*} payload
       * @param {*} callback
       * @returns
       */
       pullTallyVendorPayment = (payload, callback) => action(tallyIntegrationActionTypes.PULL_TALLY_VENDOR_PAYMENT.REQUEST, {
         payload, callback,
       })

       /**
       *
       * @param {*} pullTallyVendorPaymentLoading
       * @returns
       */
        pullTallyVendorPaymentLoading = (pullTallyVendorPaymentLoading) => action(tallyIntegrationActionTypes.PULL_TALLY_VENDOR_PAYMENT.LOADING, {
          pullTallyVendorPaymentLoading,
        })

        /**
       *
       * @param {*} payload
       * @param {*} callback
       * @returns
       */
       refreshTallyConnections = (payload, callback) => action(tallyIntegrationActionTypes.REFRESH_TALLY_CONNECTIONS.REQUEST, {
         payload, callback,
       })

       /**
      *
      * @param {*} pullTallyVendorPaymentLoading
      * @returns
      */
       refreshTallyConnectionsLoading = (refreshTallyConnectionsLoading) => action(tallyIntegrationActionTypes.REFRESH_TALLY_CONNECTIONS.LOADING, {
         refreshTallyConnectionsLoading,
       })

       /**
       *
       * @param {*} payload
       * @param {*} callback
       * @returns
       */
       pullTallyCustomers = (payload, callback) => action(tallyIntegrationActionTypes.PULL_TALLY_CUSTOMERS.REQUEST, {
         payload, callback,
       })

     /**
     *
     * @param {*} pullTallyCustomersLoading
     * @returns
     */
     pullTallyCustomersLoading = (pullTallyCustomersLoading) => action(tallyIntegrationActionTypes.PULL_TALLY_CUSTOMERS.LOADING, {
       pullTallyCustomersLoading,
     })

     getTallyDocuments = (tenantIds, documentType, startDate, endDate, page, limit, entityName, callback) => action(tallyIntegrationActionTypes.GET_TALLY_DOCUMENTS.REQUEST, {
       tenantIds, documentType, startDate, endDate, page, limit, entityName, callback,

     })

    /**
     *
     * @param {*} getTallyDocumentsLoading
     * @return
     */
    getTallyDocumentsLoading = (getTallyDocumentsLoading) => action(tallyIntegrationActionTypes.GET_TALLY_DOCUMENTS.LOADING, {
      getTallyDocumentsLoading,
    })

     /**
      * @return
      */
     getTallyDocumentsSuccess = (tallyDocuments) => action(tallyIntegrationActionTypes.GET_TALLY_DOCUMENTS.SUCCESS, {
       tallyDocuments,
     })

     getTallyUnMappedDocuments = (tenantIds, startDate, endDate, page, limit, callback) => action(tallyIntegrationActionTypes.GET_TALLY_UNMAPPED_DOCUMENTS.REQUEST, {
       tenantIds, startDate, endDate, page, limit, callback,

     })

   /**
    *
    * @param {*} getTallyUnMappedDocumentsLoading
    * @return
    */
   getTallyUnMappedDocumentsLoading = (getTallyUnMappedDocumentsLoading) => action(tallyIntegrationActionTypes.GET_TALLY_UNMAPPED_DOCUMENTS.LOADING, {
     getTallyUnMappedDocumentsLoading,
   })

    /**
     * @return
     */
    getTallyUnMappedDocumentsSuccess = (tallyUnMappedDocuments) => action(tallyIntegrationActionTypes.GET_TALLY_UNMAPPED_DOCUMENTS.SUCCESS, {
      tallyUnMappedDocuments,
    })

    syncTallyDocuments = (payload, callback) => action(tallyIntegrationActionTypes.SYNC_TALLY_DOCUMENTS.REQUEST, {
      payload, callback,
    })

  /**
  *
  * @param {*} syncTallyDocumentsLoading
  * @returns
  */
  syncTallyDocumentsLoading = (syncTallyDocumentsLoading) => action(tallyIntegrationActionTypes.SYNC_TALLY_DOCUMENTS.LOADING, {
    syncTallyDocumentsLoading,
  })

  updateTallyDocuments = (payload, callback) => action(tallyIntegrationActionTypes.UPDATE_TALLY_EXCLUDED_DOCUMENTS.REQUEST, {
    payload, callback,
  })

/**
*
* @param {*} updateTallyDocumentsLoading
* @returns
*/
updateTallyDocumentsLoading = (updateTallyDocumentsLoading) => action(tallyIntegrationActionTypes.UPDATE_TALLY_EXCLUDED_DOCUMENTS.LOADING, {
  updateTallyDocumentsLoading,
})

getTallyDocumentsCount = (tenantIds, callback) => action(tallyIntegrationActionTypes.TALLY_DOCUMENTS_COUNT.REQUEST, {
  tenantIds, callback,

})

/**
*
* @param {*} getTallyDocumentsCountLoading
* @return
*/
getTallyDocumentsCountLoading = (getTallyDocumentsCountLoading) => action(tallyIntegrationActionTypes.TALLY_DOCUMENTS_COUNT.LOADING, {
  getTallyDocumentsCountLoading,
})

/**
* @return
*/
getTallyDocumentsCountSuccess = (tallyDocumentsCount) => action(tallyIntegrationActionTypes.TALLY_DOCUMENTS_COUNT.SUCCESS, {
  tallyDocumentsCount,
})
}

export default new TallyIntegrationActions();
